import { useMutation } from '@tanstack/react-query';

import { env } from '@/constants/env';
import { MutationConfig } from '@/lib/react-query';

type RenderImageOptions = {
  mutationConfig?: MutationConfig<typeof renderImage>;
};

type RenderImageType = {
  image: Blob;
  roomtype: string;
  style: string;
  colors?: string[];
  materials?: string[];
};

const renderImage = async ({ image, roomtype, style, colors, materials }: RenderImageType) => {
  const formData = new FormData();
  formData.append('image', image);
  formData.append('roomtype', roomtype);
  formData.append('style', style);
  formData.append('colors', colors?.join(' ') ?? '');
  formData.append('materials', materials?.join(' ') ?? '');
  const response = await fetch(`${env.AI_API_URL}/render_image`, {
    method: 'post',
    body: formData,
    headers: {
      auth: `Bearer ${env.AI_API_TOKEN}`,
    },
  });
  return response.json();
};

export const useRenderImage = ({ mutationConfig }: RenderImageOptions = {}) => {
  return useMutation({
    ...mutationConfig,
    mutationFn: renderImage,
  });
};
